"use client";

import { useEffect } from "react";
import { ErrorFallback } from "@/components/error-capture/error-fallback";
import { reportBoundaryError } from "@/components/error-capture/report-boundary-error";

/**
 * App-wide error boundary (route-segment level). Before this file
 * existed the app had NO error.tsx anywhere, so any uncaught render
 * error — or an unhandled rejection inside a transition — surfaced
 * as Next's unstyled production error screen. This is the generic
 * backstop; the active-workout route has its own error.tsx with
 * surface-specific reassurance copy.
 *
 * Next 16 note: the retry prop is `unstable_retry` (the pre-16
 * `reset` prop is gone). It re-renders the segment; for transient
 * failures (flaky connection during a server-component fetch)
 * that's usually enough to recover in place.
 */
export default function Error({
  error,
  unstable_retry,
}: {
  error: Error & { digest?: string };
  unstable_retry: () => void;
}) {
  useEffect(() => {
    // Feed the admin error log (error_log via logClientError) —
    // boundary-caught errors never reach the window listeners.
    reportBoundaryError(error);
  }, [error]);

  return <ErrorFallback onRetry={() => unstable_retry()} />;
}
